import { render, staticRenderFns } from "./SharedFileList.vue?vue&type=template&id=ea0ab45c&scoped=true"
import script from "./SharedFileList.vue?vue&type=script&lang=js"
export * from "./SharedFileList.vue?vue&type=script&lang=js"
import style0 from "./SharedFileList.vue?vue&type=style&index=0&id=ea0ab45c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0ab45c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea0ab45c')) {
      api.createRecord('ea0ab45c', component.options)
    } else {
      api.reload('ea0ab45c', component.options)
    }
    module.hot.accept("./SharedFileList.vue?vue&type=template&id=ea0ab45c&scoped=true", function () {
      api.rerender('ea0ab45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/File/SharedFileList.vue"
export default component.exports